export default __webpack_public_path__ + "static/media/comfortable_mode.33411bbc.png";